import url from "wasm:/opt/buildhome/repo/node_modules/@insights-gaming/video-probe/probe.wasm";export default () => WebAssembly.compileStreaming(fetch(url));